import { forwardRef, useEffect, useImperativeHandle, useRef, useState, useContext } from "react";
import { Howl, Howler } from "howler";
import BetPlacedChip from "../../../../../../library/Chips/BetChip";
import CasinoholdemContainer from "./CasinoholdemCardsContainer";
import '../NewUI/NewCasinoHold.scss'

import betChipSnd from "../../../../../../assets/sounds/pokerchip_snd.mp3"
import CardFallSnd from "../../../../../../assets/sounds/slide.mp3"
import dealerCardsSnd from "../../../../../../assets/sounds/dealercards_reavel.mp3"
import clearSnd from "../../../../../../assets/sounds/clear.mp3"
import btnClickSnd from "../../../../../../assets/sounds/bet.mp3"
import menuSnd from "../../../../../../assets/sounds/checkbox.mp3"
import pokerChipSnd from "../../../../../../assets/sounds/pokerChip.mp3"
import glowSnd from "../../../../../../assets/sounds/successNew.mp3"

import { MyContextHoldem } from '../CasinoHoldem';
import 'animate.css';

const chipWidth = 150;
const chipHeight = 150;

const Holdemgameboard = forwardRef((props, ref) => {
    const [animatedChips, setAnimatedChips] = useState([])
    const [isAntechipanim, setAntechipanim] = useState(true);
    const [isBonuschipanim, setBonuschipanim] = useState(false);
    const [isRaisechipanim, setRaisechipanim] = useState(false);
    const [bettype, setBettype] = useState("");
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [antebetholdem, setAntebetholdem] = useState(0);
    const [bonusbetholdem, setbonusbetholdem] = useState(0);
    const [betHistory, setBetHistory] = useState([]);
    const debounceRef = useRef(false);
    const soundsRef = useRef({});
    const playerCardsRef = useRef()
    const dealerCardsRef = useRef()
    const boardCardsRef = useRef()
    const {
        cardblink, setCardblink,
        delaerhand, setdealerHandmessage,
        raiseAmount, setraiseAmount,
        betAmount, setBetAmount,
        bonusAmount, setbonusAmount,
        betBtn, setBetBtn,
        clearBtn, setClearBtn,
        undoBtn, setUndoBtn,
        selectedChip, setChipCount,
        infoText, setInfoText,
        winAmount, setWinAmount,
        totalbets, settotalbets,
        duplicateBetAmount, setDuplicateBetAmount,
        shouldPulse, setShouldPulse,
        isBonusaction, setisBonusaction,
        isBetaction, setisBetaction,
        bonusactive, setBonusactive,
        Raiseactive, setRaiseactivated,
        Enableclick, setEnableclick

    } = useContext(MyContextHoldem);



    useImperativeHandle(ref, () => ({
        startDealingCards,
        prevstatestartDealingCards,
        revealDealerCards,
        clearallHoldemcards,
        setHandMessages: (playerHand, dealerHand) => {
            playerCardsRef?.current.setPlayerHandmessage(playerHand)
            dealerCardsRef?.current.setdealerHandmessage(dealerHand)

        },
        toggleMute: (newMuteState) => { Howler?.mute(newMuteState); },
        playChipSound: () => {
            soundsRef.current?.pokerChipSound?.stop()
            soundsRef.current?.pokerChipSound?.play()
        },
        playWinGlowSound: () => {
            soundsRef.current?.winGlowSound?.stop()
            soundsRef.current?.winGlowSound?.play()
        },
        playMenuSound: () => {
            soundsRef.current?.menuSound?.stop()
            soundsRef.current?.menuSound?.play()
        },
    }))
    useEffect(() => {
        const unlock = () => {
            if (!soundsRef.current?.cardFallSound) {
                soundsRef.current = {
                    cardFallSound: new Howl({ src: [CardFallSnd], html5: true }),
                    dealerCardRevealSound: new Howl({ src: [dealerCardsSnd], html5: true }),
                    // cardClickSound: new Howl({ src: [CardSelectSnd], html5: true }),
                    betChipSound: new Howl({ src: [betChipSnd], html5: true }),
                    // CardInvalidSelectSound: new Howl({ src: [CardInvalidSelectSnd], html5: true }),
                    // messageSound: new Howl({ src: [msgSnd], html5: true }),
                    clearSound: new Howl({ src: [clearSnd], html5: true }),
                    // lostSound: new Howl({ src: [loseSnd], html5: true }),
                    btnClickSound: new Howl({ src: [btnClickSnd], html5: true }),
                    menuSound: new Howl({ src: [menuSnd], html5: true }),
                    pokerChipSound: new Howl({ src: [pokerChipSnd], html5: true }),
                    winGlowSound: new Howl({ src: [glowSnd], html5: true }),
                };
            }
            window.removeEventListener("touchstart", unlock);
            window.removeEventListener("click", unlock);
        };

        window.addEventListener("touchstart", unlock, { once: true });
        window.addEventListener("click", unlock, { once: true });
    }, []);


    useEffect(() => {
        if (props.gameState?.betRequest?.anteBetAmount > 0 && props.gameState?.betRequest?.bonusBet > 0) {


        }


        setBetHistory([])
        console.log(betHistory)


    }, []);
    const closePopup = () => {
        setIsPopupOpen(false);
    };

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") closePopup();
        };

        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, []);


    //    ......................commented on 170926  .......................useEffect(() => {

    //     if (antebetholdem <= 0) return;

    //     let newBetAmount = 0;
    //     let newBetAmountBonus = 0;

    //     const anteBet = Number(props?.gameState?.betRequest?.anteBetAmount || 0);
    //     const bonusBet = Number(props?.gameState?.betRequest?.bonusBet || 0);

    //     if (bettype === "rebet" || bettype === "rebetx2") {
    //         if (anteBet > 0 || bonusBet > 0) {
    //             if (bettype === "rebet") {
    //                 newBetAmount = anteBet;
    //                 newBetAmountBonus = bonusBet;
    //             } else {
    //                 newBetAmount = anteBet * 2;
    //                 newBetAmountBonus = bonusBet * 2;
    //             }

    //             settotalbets(newBetAmount + newBetAmountBonus);
    //             setisBetaction(true);
    //             setisBonusaction(true);

    //             console.log("Rebet Amount:", newBetAmount);
    //         }
    //     } else {

    //         const chipValue = Number(props.chipsArray.split(",")[selectedChip] || 0);


    //         setBetHistory(prev => [...prev, { type: "bet", chipValue }]);

    //         setBettype("");
    //         setisBetaction(true);
    //         setisBonusaction(true);
    //         console.log("Chip value placed:", chipValue);
    //         settotalbets(totalbets + chipValue)
    //     }
    // }, [antebetholdem]);




    
    useEffect(() => {

        if (antebetholdem <= 0) return;

        let newBetAmount = 0;
        let newBetAmountBonus = 0;

        const anteBet = Number(props?.gameState?.betRequest?.anteBetAmount || 0);
        const bonusBet = Number(props?.gameState?.betRequest?.bonusBet || 0);

        
// const chipValue = Number(props.chipsArray.split(",")[selectedChip]);
        const currentBet = Number(betAmount);

        const newBetAmountdouble = Number((currentBet).toFixed(2));
   


        const possibleRaise = newBetAmountdouble * 2;
        const totalRequired = newBetAmountdouble + possibleRaise+bonusAmount;


        if (totalRequired <= Number(props.balance)){

        
        if (bettype === "rebet" || bettype === "rebetx2") {
            if (anteBet > 0 || bonusBet > 0) {
                if (bettype === "rebet") {
                    newBetAmount = anteBet;
                    newBetAmountBonus = bonusBet;
                } else {
                    newBetAmount = anteBet * 2;
                    newBetAmountBonus = bonusBet * 2;
                }

                settotalbets(newBetAmount + newBetAmountBonus);
                setisBetaction(true);
                setisBonusaction(true);

                console.log("Rebet Amount:", newBetAmount);
            }
        } else {

            const chipValue = Number(props.chipsArray.split(",")[selectedChip] || 0);


            setBetHistory(prev => [...prev, { type: "bet", chipValue }]);

            setBettype("");
            setisBetaction(true);
            setisBonusaction(true);
            console.log("Chip value placed:", chipValue);
            settotalbets(totalbets + chipValue)
        }
    }
    else{
         showPopupMessage(`Not enough balance to cover both Ante and Bonus and Call!`);
    }

    }, [antebetholdem]);

    useEffect(() => {

        if (bonusbetholdem > 0) {


            if (bettype === "rebet" || bettype === "rebetx2") {

            }
            else {
                console.log(totalbets)
                setBettype("")
                const chipValue = Number(props.chipsArray.split(",")[selectedChip]);
                setBetHistory(prev => [...prev, { type: 'bonus', chipValue }]);
                // settotalbets(totalbets + chipValue)
                settotalbets(totalbets + chipValue)
            }


        }
        setisBetaction(true)
    }, [bonusbetholdem]);

    const showPopupMessage = (message) => {
        setPopupMessage(message);
        setIsPopupOpen(true);
    };


    const startChipAnimation = () => {
        if (debounceRef.current) return;
        debounceRef.current = true;

        const chipId = Date.now(); // unique id
        setAnimatedChips((prev) => [...prev, chipId]);
        soundsRef.current?.betChipSound?.stop()
        soundsRef.current?.betChipSound?.play()
        setTimeout(() => {
            setAnimatedChips((prev) => prev.filter((id) => id !== chipId));
            debounceRef.current = false;
        }, 200);
    };


    const handleOnClick = (type) => {
        soundsRef.current?.btnClickSound?.stop()
        soundsRef.current?.btnClickSound?.play()
        switch (type) {
            case "CLEAR": clickOnClearBtn(); break;
            case "DEAL": clickOnDealBtn(); break;
            case "UNDO": clickOnUndoBtn(); break;
            case "BONUS": clickOnBonusBtn(); break;
            case "CALL": clickOnRaiseBtn(); break;
            case "FOLD": clickOnFoldHand(); break;
            case "REBET": clickOnRebetBtn("rebet"); break;
            case "REBETx2": clickOnRebetBtn("rebetx2"); break;
            default: break;
        }
    }

    const clickOnDealBtn = () => {
        setisBetaction(false)
        setisBonusaction(false)
        setShouldPulse(false)
        setBonusactive(false)
        setEnableclick(true)
        const body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "CASINO_HOLDEM_BET",
            "object": {
                "gameId": Number(props.gameId),
                "playerId": Number(props.playerId),
                "anteBetAmount": betAmount,
                "bonusBet": bonusAmount,
                "action": "BET",
                "handId": Number(props.gameState.handId)
            },
        }
        props.network.sendof(body);
        setBetBtn("")
        setClearBtn("")
        setUndoBtn("")
        setInfoText('Your Bet Acceptance is Under Consideration !! Please wait until its Confirmed')
    }

    const clickOnFoldHand = () => {
        const body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "CASINO_HOLDEM_BET",
            "object": {
                "gameId": props.gameId,
                "playerId": Number(props.playerId),
                "action": "FOLD",
                "handId": Number(props.gameState.handId)
            },
        }
        props.network.sendof(body);
        setBetBtn("")
        setClearBtn("")
    }




    const clearallHoldemcards = () => {
        dealerCardsRef?.current?.clearallcards()
        boardCardsRef?.current?.clearallcards()
        playerCardsRef?.current?.clearallcards()
    }

    const clickOnBetBtn = () => {
        setBettype("")
        const chipValue = Number(props.chipsArray.split(",")[selectedChip]);
        const currentBet = Number(betAmount);

        const newBetAmount = Number((currentBet + chipValue).toFixed(2));
        console.log(betAmount)

        console.log(currentBet)

        console.log(chipValue)
        console.log(newBetAmount)



        const possibleRaise = newBetAmount * 2;
        const totalRequired = newBetAmount + possibleRaise+bonusAmount;


        if (
            totalRequired <= Number(props.balance) &
            newBetAmount <= Number(props.balance) &&
            newBetAmount <= Number(props.maxBetAmt) &&
            newBetAmount >= props.minBetAmt
        ) {

            clearallHoldemcards();

            startChipAnimation();
            setisBonusaction(true)
            setTimeout(() => {
                setBetAmount(newBetAmount);
                setAntebetholdem(prev => {
                    if (prev === newBetAmount) return prev;
                    return newBetAmount;
                });
                // setAntebetholdem(newBetAmount)..........................commentedon 0160626
                setDuplicateBetAmount(totalbets + chipValue)
            }, 200)
            if (newBetAmount > 0) {
                setBetBtn("DEAL")
                setClearBtn("CLEAR")
                setUndoBtn("UNDO")
                setBonusactive(true)
                setAntechipanim(true)
                setBonuschipanim(false)
                setRaisechipanim(false)
                // seistadaBonuschip(false)
                // setistadaAntechip(false)

            }

            setInfoText(`${props?.language?.MinBetAmt} ${props?.minBetAmt} ${props?.language?.MaxBetAmt} ${props?.maxBetAmt}`);

            //   setInfoText('You can also place bets on Bonus')

        } else {

            if (newBetAmount > Number(props.balance)) {

                showPopupMessage("Insufficient Funds!!!");
            } else if (newBetAmount > props.maxBetAmt) {
                showPopupMessage(`Maximum Bet Amount Reached!! Your Maximum Bet Amount is ${props.maxBetAmt}`);
            } else if (newBetAmount < props.minBetAmt) {
                showPopupMessage(`Minimum Bet Amount is Required!! Your Minimum Bet Amount is ${props.minBetAmt}`);
            }
            else if (totalRequired > Number(props.balance)) {
                showPopupMessage("Not enough balance to cover both Ante and possible Call!")
            }
        }
    };




    const clickOnBonusBtn = () => {

        setBettype("")


        const chipValue = Number(props.chipsArray.split(",")[selectedChip]);
        const currentBet = Number(bonusAmount);
        const newBetAmount = Number((currentBet + chipValue).toFixed(2));
        const possibleRaise = betAmount * 2;
        const totalRequired = betAmount + newBetAmount + possibleRaise;
        console.log(newBetAmount)

        if (
            totalRequired <= Number(props.balance) &&

            newBetAmount <= Number(props.balance) &&

            newBetAmount <= props.maxBetAmt &&
            newBetAmount >= props.minBetAmt
        ) {

            setAntechipanim(false)
            setRaisechipanim(false)
            setBonuschipanim(true)

            startChipAnimation();
            setTimeout(() => {
                console.log(newBetAmount)
                setbonusAmount(newBetAmount);

                // setbonusbetholdem(newBetAmount)......................commente on 160626
                // setbonusbetholdem(prev => {
                //     if (prev === newBetAmount) return prev;
                //     return newBetAmount;
                // });

                setbonusbetholdem(prev => {
                    console.log("prev:", prev);
                    console.log("newBetAmount:", newBetAmount);

                    if (prev === newBetAmount) return prev;
                    return newBetAmount;
                });
                setDuplicateBetAmount(totalbets + chipValue)

            }, 200)
            if (newBetAmount > 0) {
                setBetBtn("DEAL")
                setClearBtn("CLEAR")
                setUndoBtn("UNDO")
                // setAntechipanim(false)
            }
            // 3. Update info text
            setInfoText(`${props?.language?.MinBetAmt} ${props?.minBetAmt} ${props?.language?.MaxBetAmt} ${props?.maxBetAmt}`);
        } else {
            if (newBetAmount > Number(props.balance)) {
                showPopupMessage("Insufficient Funds!!!");
            }
            else if (newBetAmount > props.maxBetAmt) {
                showPopupMessage(`Maximum Bet Amount Reached!! Your Maximum Bet Amount is ${props.maxBetAmt}`);
            }
            else if (newBetAmount < props.minBetAmt) {
                showPopupMessage(`Minimum Bet Amount is Required!! Your Minimum Bet Amount is ${props.minBetAmt}`);
            }
            else if (totalRequired > Number(props.balance)) {
                // setInfoText("Not enough balance to cover both Ante and Bonus and possible Call!");
                showPopupMessage(`Not enough balance to cover both Ante and Bonus and Call!`);
            }
        }
        // props.setBetAmount(0);
        // props.setBetBtn("BET")
        // props.setClearBtn("")
        // props.setUndoBtn("")
    }

    const clickOnRaiseBtn = () => {
        // setShouldPulse(false)
        let raisetotalbet = betAmount * 2
        setraiseAmount(raisetotalbet)
        setRaiseactivated(false)

        const body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "CASINO_HOLDEM_BET",
            "object": {
                "gameId": props.gameId,
                "playerId": props.playerId,
                "action": "CALL",
                "handId": Number(props.gameState.handId)
            },
        }
        props.network.sendof(body);
        setInfoText("")
        setBetBtn("")
        setClearBtn("")
        setUndoBtn("")
        const currentBet = Number(raisetotalbet);
        const newBetAmount = currentBet;
        setAntechipanim(false)
        setBonuschipanim(false)
        setRaisechipanim(true)
        console.log(newBetAmount)
        console.log(Number(props.balance))
        console.log(props.maxBetAmt)
        console.log(props.minBetAmt)
        if (
            newBetAmount <= Number(props.balance)
            //  &&
            // newBetAmount <= props.maxBetAmt &&
            // newBetAmount >= props.minBetAmt
        ) {

            settotalbets(totalbets + raisetotalbet)
            // setDuplicateBetAmount(totalbets + raisetotalbet)
            setDuplicateBetAmount(raisetotalbet)

            console.log(totalbets + raisetotalbet)

            startChipAnimation();
            setTimeout(() => {
                // props.setraiseAmount(newBetAmount);
            }, 200)

        } else {
            if (newBetAmount > Number(props.balance)) {

                showPopupMessage("Insufficient Funds!!!");
            }
            // else if (newBetAmount > props.maxBetAmt) {
            //     showPopupMessage(`Maximum Bet Amount Reached!! Your Maximum Bet Amount is ${props.maxBetAmt}`);
            // } 
            // else if (newBetAmount < props.minBetAmt) {
            //     showPopupMessage(`Minimum Bet Amount is Required!! Your Minimum Bet Amount is ${props.minBetAmt}`);
            // }
        }

    }


    const clickOnUndoBtn = () => {
        let newBetAmount
        let newBetAmountbonus

        if (bettype === "rebet" || bettype === "rebetx2") {


            if (Number(props.gameState.betRequest.anteBetAmount > 0 || Number(props.gameState.betRequest.bonusBet > 0))) {
                if (bettype === "rebet") {

                    newBetAmount = Number(props.gameState.betRequest.anteBetAmount);
                    newBetAmountbonus = Number(props.gameState.betRequest.bonusBet);

                }
                else {

                    newBetAmount = Number(props.gameState.betRequest.anteBetAmount) * 2;

                    newBetAmountbonus = Number(props.gameState.betRequest.bonusBet) * 2;
                }

                let totaldecuctrebetantebonus = newBetAmount + newBetAmountbonus
                let totalrebetantebonusbets = betAmount + bonusAmount
                console.log(totaldecuctrebetantebonus)
                console.log(totalrebetantebonusbets)
                let finalbetsafterrebet = totalrebetantebonusbets - totaldecuctrebetantebonus
                setBetAmount(finalbetsafterrebet);
                setbonusAmount(finalbetsafterrebet);
                setDuplicateBetAmount(totalbets - totaldecuctrebetantebonus)
                settotalbets(totalbets - totaldecuctrebetantebonus)
                let Totalbetseualtozero = totalbets - totaldecuctrebetantebonus
                if (Totalbetseualtozero == 0) {

                    setBetAmount(0);
                    setAntebetholdem(0)
                    settotalbets(0)
                    setbonusAmount(0);
                    setbonusbetholdem(0)
                    setBetBtn("")
                    setClearBtn("")
                    setUndoBtn("")
                    setShouldPulse(true)
                    setDuplicateBetAmount(0)
                    setBonusactive(false)
                    setisBetaction(true)
                    setisBonusaction(false)
                    setBettype("")
                    setBetHistory([])
                    setInfoText('Place your bets on ANTE to start the game.')
                    console.log(isBonusaction)
                }


            }


        }
        else {

            setBetHistory(prev => {
                if (prev.length === 0) return prev;

                const lastBet = prev[prev.length - 1];
                const updatedHistory = prev.slice(0, -1);
                let newTotal
                let AnteHoldemFinalBets
                console.log(betAmount)
                if (lastBet.type === 'bet') {
                    if (betAmount > 0) {
                        let totalholdembets = Number(totalbets).toFixed(1)
                        let totalbetsholdem = Number(betAmount).toFixed(1)
                        newTotal = totalholdembets - lastBet.chipValue;
                        setBetAmount(totalbetsholdem - lastBet.chipValue);
                        console.log(totalholdembets)
                        console.log(newTotal)
                        setDuplicateBetAmount(newTotal)
                        settotalbets(newTotal)

                        // AnteHoldemFinalBets=newBetAmount-lastBet.chipValue
                        // setBetAmount(AnteHoldemFinalBets)
                    }

                    // reverseChipAnimation(lastBet.chipValue)
                } else if (lastBet.type === 'bonus') {

                    if (bonusAmount > 0) {
                        let totalholdembets = Number(totalbets).toFixed(1)
                        let totalbetsholdem = Number(bonusAmount).toFixed(1)
                        newTotal = totalholdembets - lastBet.chipValue;
                        let finalholdembonusbet = totalbetsholdem - lastBet.chipValue

                        setbonusAmount(finalholdembonusbet);

                        setDuplicateBetAmount(newTotal)

                        settotalbets(newTotal)
                    }

                }

                if (newTotal == 0) {

                    resetBets();
                }

                return updatedHistory;

            });

            if (betHistory.length == 0) {
                resetBets();
            }
        }

    };

    const resetBets = () => {

        setBetAmount(0);
        setAntebetholdem(0);
        settotalbets(0);
        setbonusAmount(0);
        setbonusbetholdem(0);
        setBetBtn("");
        setClearBtn("");
        setUndoBtn("");
        setShouldPulse(true);
        setDuplicateBetAmount(0);
        setBonusactive(false);
        setisBetaction(true);
        setisBonusaction(false);
        setBettype("");
        setBetHistory([]);
        setInfoText('Place your bets on ANTE to start the game.');
    };


    const clickOnClearBtn = () => {
        setBetAmount(0);
        setAntebetholdem(0)
        settotalbets(0);
        setbonusAmount(0);
        setbonusbetholdem(0)
        setBetBtn("");
        setClearBtn("");
        setUndoBtn("");
        setDuplicateBetAmount(0);
        setBonusactive(false);
        setisBetaction(true);
        setisBonusaction(false);
        setBettype("");
        setInfoText('Place your bets on ANTE to start the game.');
        setBetHistory([]);

    }

    const clickOnRebetBtn = (type) => {
        let chipValue
        let newBetAmount
        let newBetAmountbonus
        setisBonusaction(true);
        setisBetaction(true);
        if (props.gameState?.betRequest?.anteBetAmount > 0) {
            if (type === "rebet" || type === "rebetx2") {
                clearallHoldemcards();
                if (type === "rebet") {
                    setBettype("rebet");
                    chipValue = Number(props.chipsArray.split(",")[selectedChip]);
                    newBetAmount = Number(props.gameState.betRequest.anteBetAmount);
                    newBetAmountbonus = Number(props.gameState.betRequest.bonusBet);
                    // console.log(Number(props.gameState.betRequest.anteBetAmount))
                    // console.log(Number(props.gameState.betRequest.bonusBet))
                    // console.log(newBetAmount)
                    // console.log(newBetAmountbonus)
                }
                else {
                    setBettype("rebetx2");
                    newBetAmount = Number(props.gameState.betRequest.anteBetAmount) * 2;
                    newBetAmountbonus = Number(props.gameState.betRequest.bonusBet) * 2;

                }
            }

            let totalbetsantebonus = Number(newBetAmount) * 2 + Number(newBetAmountbonus)

            if (
                totalbetsantebonus <= Number(props.balance) &&
                newBetAmount <= props.maxBetAmt &&
                newBetAmount >= props.minBetAmt
            ) {
                // console.log(totalbetsantebonus)
                if (totalbetsantebonus <= props.balance) {
                    setBetAmount(newBetAmount);
                    setAntebetholdem(newBetAmount);
                    settotalbets(newBetAmount);
                    setDuplicateBetAmount(newBetAmount);
                    if (newBetAmount > 0) {
                        setBetBtn("DEAL");
                        setClearBtn("CLEAR");
                        setUndoBtn("UNDO");
                        setBonusactive(true);
                        setAntechipanim(true);
                        setBonuschipanim(false);
                        setRaisechipanim(false);
                    }
                    setInfoText(`${props?.language?.MinBetAmt} ${props?.minBetAmt} ${props?.language?.MaxBetAmt} ${props?.maxBetAmt}`);
                }

            } else {
                if (totalbetsantebonus > Number(props.balance)) {
                    setisBonusaction(false);

                     showPopupMessage(`Not enough balance to cover both Ante and Bonus and Call!`);
                } else if (newBetAmount > props.maxBetAmt) {
                    showPopupMessage(`Maximum Bet Amount Reached!! Your Maximum Bet Amount is ${props.maxBetAmt}`);
                } else if (newBetAmount < props.minBetAmt) {
                    showPopupMessage(`Minimum Bet Amount is Required!! Your Minimum Bet Amount is ${props.minBetAmt}`);
                }
            }
            setAntechipanim(false);
            setRaisechipanim(false);
            setBonuschipanim(true);
        }
        if (props.gameState?.betRequest?.bonusBet > 0) {
            let totalbetsantebonus = Number(newBetAmount) * 2 + Number(newBetAmountbonus)


            if (
                totalbetsantebonus <= Number(props.balance)
                &&
                newBetAmount <= props.maxBetAmt &&
                newBetAmount >= props.minBetAmt
            ) {

                if (totalbetsantebonus <= props.balance) {
                    setbonusAmount(newBetAmountbonus);
                    setbonusbetholdem(newBetAmountbonus);
                    settotalbets(newBetAmount + newBetAmountbonus);
                    setDuplicateBetAmount(newBetAmount + newBetAmountbonus);

                    if (newBetAmountbonus > 0) {
                        setBetBtn("DEAL");
                        setClearBtn("CLEAR");
                        setUndoBtn("UNDO");

                    }
                    setInfoText(`${props?.language?.MinBetAmt} ${props?.minBetAmt} ${props?.language?.MaxBetAmt} ${props?.maxBetAmt}`);
                }

            } else {
                setisBonusaction(false);
                if (totalbetsantebonus > Number(props.balance)) {
                    showPopupMessage("Insufficient Funds!!!");
                }
                // else if (totalbetsantebonus > props.maxBetAmt) {
                //     showPopupMessage(`Maximum Bet Amount Reached!! Your Maximum Bet Amount is ${props.maxBetAmt}`);
                // } 
                // else if (totalbetsantebonus < props.minBetAmt) {
                //     showPopupMessage(`Minimum Bet Amount is Required!! Your Minimum Bet Amount is ${props.minBetAmt}`);
                // }
            }

        }


    }


    const startDealingCards = (res) => {
        // console.log(res?.playerCards)
        playerCardsRef?.current?.setPlayerAllCards(res?.playerCards);
        setTimeout(() => {
            dealerCardsRef?.current?.setDealerUnsetCardshold(res?.dealerCards);



        }, 1000)
        setTimeout(() => {

            boardCardsRef?.current?.setDealerUnsetCards(res?.boardCards);
        }, 2000)

    }


    const prevstatestartDealingCards = (res) => {
        // console.log(res)
        playerCardsRef?.current?.setPlayerAllCards(res?.playerCards);

        dealerCardsRef?.current?.prevstatesetDealerUnsetCardshold(res?.dealerCards);
        boardCardsRef?.current?.prevstatesetDealerUnsetCards(res?.boardCards);

    }


    const revealDealerCards = (res) => {
        dealerCardsRef?.current?.revealDealerCards(res?.dealerCards);

        boardCardsRef?.current?.revealBoardcards(res?.boardCards);




    }

    return <div>
        <div id="holdemTable">
            <div id="cardDispenserholdem"></div>


            <div id="tableCenterCircle" className="betPanelRow">
                {/* ANTE */}
                <div className="betPanelWrapper">
                    <div className={shouldPulse ? 'AtebetplaceareGlow glow_Ante animate__animated animate__pulse animate__infinite' : ''}></div>
                    <div id="circleHoldembets" className="circleHoldembets" onClick={isBetaction ? clickOnBetBtn : () => { }}>
                        <span className="betLabel">Ante</span>
                        {betAmount !== 0 && (
                            <button disabled={!isBetaction} className="betPlacedChipBoxholdem">
                                <BetPlacedChip chipHeight={chipHeight} chipWidth={chipWidth} displayType="bet" betAmount={betAmount.toFixed(2)} chipString={props.chipsArray} gameId={Number(props.gameId)} />
                            </button>
                        )}
                    </div>

                </div>

                {/* BONUS */}
                <div className="betPanelWrapper">
                    <div className={bonusactive ? 'BonusplaceareGlow glow animate__animated animate__pulse animate__infinite' : ''}></div>
                    <div id="tablBonusCircle" className="circleHoldembets" onClick={isBonusaction ? clickOnBonusBtn : () => { }}>
                        <span className="betLabel">Bonus</span>
                        {bonusAmount !== 0 && (
                            <button
                                disabled={!isBonusaction}
                                className="betPlacedChipBoxholdem">

                                <BetPlacedChip chipHeight={chipHeight} chipWidth={chipWidth} displayType="bonus" betAmount={bonusAmount.toFixed(2)} chipString={props.chipsArray} gameId={Number(props.gameId)} />
                            </button>
                        )}
                    </div>
                </div>

                {/* CALL */}
                <div className="betPanelWrapper">
                    <div className={Raiseactive ? 'RaiseplaceareGlow glow animate__animated animate__pulse animate__infinite' : ""}></div>
                    <div id="tableRaise" className="circleHoldembets">
                        <span className="betLabel">Call</span>
                        {raiseAmount !== 0 && (
                            <button disabled={!isBonusaction} className="betPlacedChipBoxholdem">
                                <BetPlacedChip chipHeight={chipHeight} chipWidth={chipWidth} displayType="raise" betAmount={raiseAmount.toFixed(2)} chipString={props.chipsArray} gameId={Number(props.gameId)} />
                            </button>
                        )}
                    </div>
                </div>
            </div>



            {['ante', 'bonus', 'raise'].map((type) => {
                const isActive =
                    type === 'ante' ? isAntechipanim :
                        type === 'bonus' ? isBonuschipanim :
                            isRaisechipanim;

                const className =
                    type === 'ante' ? 'betAnimationChipholdem' :
                        type === 'bonus' ? 'bonusAnimationChip' :
                            'raiseAnimationChip';

                return isActive
                    ? animatedChips.map((chipId) => (
                        <div
                            key={`${type}-${chipId}`}
                            className={className}
                            style={{ "--selectedChip": selectedChip }}
                        >
                            <BetPlacedChip chipHeight={chipHeight} chipWidth={chipWidth}
                                betAmount={props.chipsArray.split(",")[selectedChip]}
                                chipString={props.chipsArray}
                                gameId={Number(props.gameId)}
                            />
                        </div>
                    ))
                    : null;
            })}


            {[
                { id: "boardcardscontainer", ref: boardCardsRef },
                { id: "dealerCardsContainerholdem", ref: dealerCardsRef },
                {
                    id: "playerCardsContainerholdem",
                    ref: playerCardsRef,
                    isPlayer: true,
                    setInfoText: setInfoText,
                    language: props.language,
                    setClearBtn: setClearBtn,
                },
            ].map((config, index) => (
                <div id={config.id} key={index}>
                    <CasinoholdemContainer
                        ref={config.ref}
                        isPlayer={config.isPlayer}
                        setInfoText={config.setInfoText}
                        language={config.language}
                        setBetBtn={setBetBtn}
                        setClearBtn={config.setClearBtn}
                        soundsRef={soundsRef}
                    />
                </div>
            ))}

            <div className="actionBtnsBoxholdem">

                {clearBtn && <div className="axnBtnHldm" onClick={() => { handleOnClick(clearBtn) }}> <button className="actionButtonsholdem" style={{ "--btnBackClr": "rgba(0 150 255/50)", "--btnClr": "#004c87" }} id="rebetBtn"><span>{clearBtn}</span></button></div>}
                {betBtn && <div className="axnBtnHldm" onClick={() => { handleOnClick(betBtn) }}><button className="actionButtonsholdem" style={{ "--btnBackClr": "#2de92d80", "--btnClr": "#117d1d" }} id="betBtn"><span>{betBtn}</span></button></div>}
                {undoBtn && <div className="axnBtnHldm" onClick={() => { handleOnClick(undoBtn) }}><button className="actionButtonsholdem" style={{ "--btnBackClr": "rgba(208 0 65 /50)", "--btnClr": "#7c0026" }} id="clearBtn"><span>{undoBtn}</span></button></div>}
            </div>
        </div>
        <div
            id="popupOverlay"
            className={`holdem-popup-overlay ${isPopupOpen ? "show" : "hidden"}`}
            onClick={(e) => e.target.id === "popupOverlay" && closePopup()}
        >
            <div className="holdem-popup-card">
                <button className="holdem-popup-close" onClick={closePopup}>
                    ✕
                </button>

                <div className="holdem-popup-content">
                    {popupMessage}
                </div>
            </div>
        </div>


    </div>

})

export default Holdemgameboard

